import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(items) {
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.items_cart_preview');
          itensCartPreview.innerHTML = '';
    
          items.forEach((item) => {
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';
    
            let itemHTML = `
            <li class="cart-item">
              <figure>
                <img src="${item.image_medium}" alt="${item.name}">
              </figure>
              <div class="cart-item-content">
                <div class="cart-item-content-item">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                </div>
                <div class="cart-item-content-item">
                  ${variations}
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                </div>
              </div>
            </li>
            `;
    
            itensCartPreview.innerHTML += itemHTML;
          });
    
          // Adiciona o event listener para os botões de deletar
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function() {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });
        }
      }
    
      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function(data) {
        if (data && data.cart_data && data.cart_data.items) {
          updateCartPreview(data.cart_data.items);
        }
      });
    
      $(document).on("ajaxComplete", function(event, xhr, settings) {
        if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
          let valid_status = [200, 201];
          if (valid_status.includes(xhr.status)) {
            const responseJson = xhr.responseJSON.cart_data.items;
            updateCartPreview(responseJson);
          }
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

document.addEventListener("DOMContentLoaded", function () {

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      setTimeout(() => {
        const productItem = document.querySelectorAll('.product-item');
        if (productItem.length) {
          productItem.forEach((item) => {
            let optionsColors = item.querySelectorAll('.product__colors .product__colors-item');
            let more = item.querySelector('.product-item__options .more');
            if (optionsColors.length >= 5) {
              let productColors = item.querySelector('.product__colors');
              if (productColors && more) {
                productColors.appendChild(more);
              }
            }
          });
        }
      }, 500);

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

  $("body").on("click", '.not-available-grid', function (event) {
    event.preventDefault();
    var $input = $(this);
    let payload = [];
    payload.push({
      product: $input.attr('data-id'),
      quantity: 1,
      replace_quantity: true,
      is_buying_by_measure: false
    });

    if (payload.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/api/front/cart/items/?version=2',
        data: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).fail(function (jqXHR, textStatus, errorThrown) {
        var data = jqXHR.responseJSON;
        for (var i in data) {
          if ('unavailable' in data[i]) {
            var d = data[i].unavailable;
            Swal.fire({
                imageUrl: d.product.image,
                html: '<strong>' + d.product.name + '</strong>' +
                    '<p>' + d.message + '</p>',
                input: 'text',
                inputPlaceholder: 'Informe seu e-mail:',
                showCancelButton: true,
                confirmButtonText: 'Cadastrar aviso',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: function (email) {
                    return new Promise(function (resolve, reject) {
                        product_detail_service.notify('', email, {}, d.product.id);
                        resolve();
                    });
                }
            });
          }
        };
      });
    }
  });


  function b2bItens() {
    // Função para converter uma string de moeda brasileira para número
    function parseBrazilianCurrency(value) {
      // Remove os pontos de milhar e substitui a vírgula decimal por um ponto
      value = value.replace(/\./g, '').replace(',', '.');
      // Converte para número float
      return parseFloat(value);
    }

    // Armazena o valor anterior dos inputs para calcular a diferença
    let previousValues = {};

    // Função genérica para aplicar a lógica em um contêiner específico
    function applyLogicToContainer(containerSelector) {
      // Aplica a lógica aos elementos dentro do contêiner
      const $container = $(containerSelector);

      if (!$container.find('.product-radio-variation.b2b').length) {
        addToCart($container);
        return;
      }

      $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
        // Inicializa o valor anterior no carregamento da página
        previousValues[$(this).attr('id')] = parseBrazilianCurrency($(this).attr('data-price')) * Number($(this).val());
      });

      $container.find('input[id^="product_item_variation__product_detail_"]').on('change', function () {
        var $el = $(this);

        // Obtém o ID do input
        const inputId = $el.attr('id');

        // Obtém o preço da variação do atributo data-price
        const variationPrice = parseBrazilianCurrency($el.attr('data-price'));

        // Obtém a quantidade da variação
        const variationQtd = Number($el.val());

        // Calcula o valor atual baseado no preço e na quantidade
        const currentValue = variationPrice * variationQtd;

        // Obtém o preço total atual e o converte para número
        const totalValue = parseBrazilianCurrency($container.find('.price-table').attr('data-price'));

        // Calcula a diferença entre o valor atual e o valor anterior
        const previousValue = previousValues[inputId] || 0;
        const difference = currentValue - previousValue;

        // Atualiza o valor total
        const newValue = totalValue + difference;

        // Atualiza o atributo data-price com o novo valor total
        $container.find('.price-table').attr('data-price', newValue.toFixed(2).replace('.', ','));

        // Atualiza o valor anterior para o próximo cálculo
        previousValues[inputId] = currentValue;
      });

      // Lógica para adicionar ao carrinho
      addToCart($container);

    }

    function addToCart(containerSelector) {
      const $container = $(containerSelector);
      $container.find('.b2b-button').click(function () {
        let payload = [];
        let isB2b = false;
        if ($container.find('.product-radio-variation').hasClass('b2b')) {
          isB2b = true;
          $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
            let $el = $(this);
            let value = Number($el.val());
            if (value > 0) {
              payload.push({
                as_free: false,
                product: Number($el.attr('data-id')),
                quantity: value,
                replace_quantity: true,
              });
            }
          });
        }else {
          let $el = $($container).find('input[id^="product_item_variation__product_detail_"]:checked');
          let value = Number($($container).find('.product-item__qtd input').val());
          if (value > 0) {
            payload.push({
              product: Number($el.attr('data-id')),
              quantity: value,
              replace_quantity: true,
              is_buying_by_measure: false
            });
          }
        }

        if (payload.length > 0) {
          let url;
          if(isB2b) {
            url = '/api/front/cart/items/?version=2&add_grid_by_conf=1';
          }else {
            url = '/api/front/cart/items/?version=2';
          }
          $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json'
          }).done(function (data, textStatus, jqXHR) {
            if ($container.hasClass('product-detail__header--infoArea')) {
              if (conf_detalhe_produto_exibir_modal_continuar_comprando) {
                cart_preview.renderCartPreview();
                $("a.js-keeping-buying").fancybox().trigger('click');
              } else {
                location = url_carrinho;
              }
            } else {
              const overlay = document.querySelector('.header__product-item--options-overlay');
              const options = document.querySelector('.header__product-item--options');

              if (overlay && options) {
                overlay.classList.remove('active');
                options.classList.remove('active');
                options.innerHTML = '';
              }
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            handleAjaxFail(jqXHR.responseJSON);
          });
        } else {
          alert('Por favor, selecione a quantidade.');
        }
      });
    }

    // Função para tratar falhas no AJAX
    function handleAjaxFail(data) {
      data.forEach(function (item) {
        if (item.stock) {
          alert(`O produto <strong>"${item.stock.product.name}"</strong> possui <strong>${item.stock.quantity}</strong> unidade(s) em estoque.`);
          return false;
        }

        if (item.limit_itens) {
          alert(item.limit_itens.message);
          return false;
        }

        if (item.buy_rules) {
          showBuyRulesWarning(item.buy_rules);
          return false;
        }
      });
    }

    // Função para exibir regras de compra
    function showBuyRulesWarning(buyRules) {
      let warning = `
      Quantidade solicitada para esta grade: <strong>${buyRules.quantity_total_grid_on_cart}</strong><br><br>
      Para o produto <strong>${buyRules.products[0].product_parent_or_self.name}</strong> é necessário comprar a grade conforme as regras abaixo:<br><br>
      <table class="behaviour-grid__table">
          <thead>
              <tr>
                  <th><strong>Total por grade</strong></th>
                  <th><strong>Total mínimo</strong></th>
                  <th><strong>Mínimo por variação</strong></th>
              </tr>
          </thead>
          <tbody>
  `;

      buyRules.grade_rules.forEach(function (rule) {
        let isCurrentRule = parseInt(buyRules.quantity_total_grid_on_cart) === parseInt(rule.total_quantity_that_must_be_purchased_in_the_grid);
        warning += `
          <tr${isCurrentRule ? ' style="color:red; text-decoration: underline;"' : ''}>
              <td>${formatRuleQuantity(rule.total_quantity_that_must_be_purchased_in_the_grid, rule.total_quantity_must_be_multiple_of_itself)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_in_the_grid)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_by_product, rule.minimum_amount_must_be_multiple_of_itself, rule)}</td>
          </tr>
      `;
      });

      warning += '</tbody></table>';
      alert(warning);
    }

    // Formatação das quantidades de regras
    function formatRuleQuantity(quantity, isMultiple = false, rule = null) {
      if (!quantity) return 'sem limite';
      let formatted = isMultiple ? `múltiplo de ${quantity}` : `${quantity}`;
      if (rule) {
        if (!rule.close_grid) formatted += ' (grade aberta)';
        else formatted += ` (grade fechada${rule.variations_not_required ? ` (não obrigatório: ${rule.variations_not_required.split(",").join(", ")})` : ''})`;
      }
      return formatted;
    }

    // Executa a função para os dois contextos diferentes
    applyLogicToContainer('.product-detail__header--infoArea');

  }

  b2bItens();

});